<kendo-grid-filter-wrapper-cell [column]="column" [filter]="filter" [operators]="operators" [defaultOperator]="operator"
 [showOperators]="showOperators">
	<kendo-dropdownlist kendoFilterInput kendoGridFocusable [data]="data" [textField]="textField" [valueField]="valueField" [valuePrimitive]="valuePrimitive"
	 [popupSettings]="{width:'auto',height:300}" [ngModel]="currentFilter?.value"
	 (valueChange)="onChange($event)">
	</kendo-dropdownlist>
</kendo-grid-filter-wrapper-cell>